import React, { useState, useEffect } from 'react';
import { Row, Col, Modal, Button, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Card from '../../../components/Card'; // Assuming the same Card component is used
import { getApiCall } from '../../../service/getApiCall';
import { API_AGENTS_LIST, API_SINGLE_AGENT_GROUP, API_AGENT_GROUP_ASSIGNED_AGENTS, API_AGENT_GROUP_STRATEGY, API_PROMPT_ACTIVE_LIST, API_CALL_STRATEGIES_MASTER_LIST } from '../../../service/url';
import { useLocation } from 'react-router-dom';
import { postApiCall } from '../../../service/postApiCall';
import { useNavigate } from 'react-router-dom';
import { Toaster, toast } from 'react-hot-toast';
import LottieAnimation from '../../../components/lottie/lottie';
import './slider.css'
import { DeleteIcon, EditIcon } from '../../../components/setting/elements';
import { BACKEND_API_BASE_URL } from "../../../utilities/constant";
import { FiInfo } from 'react-icons/fi';

const GroupSettings = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [showAddMembersModal, setShowAddMembersModal] = useState(false);
    const [agentGroup, setAgentGroup] = useState({});
    const [showTimeScheduleModal, setShowTimeScheduleModal] = useState(false);
    const [showWhisperModal, setShowWhisperModal] = useState(false);
    const [agents, setAgents] = useState([]);
    const [showCallStrategyModal, setShowCallStrategyModal] = useState(false);

    const [selectedAgentIds, setSelectedAgentIds] = useState([]);
    const [startTime, setStartTime] = useState("00:00");
    const [endTime, setEndTime] = useState("23:59");

    const [weekDays, setWeekDays] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);
    const [memberWeekDays, setmemberWeekDays] = useState(["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]);
    const [selectedStrategy, setSelectedStrategy] = useState("ROUNDROBIN RINGING");
    const [sticky, setSticky] = useState(false)
    const [stickyMember, setStickyMember] = useState('off'); // 'normal', 'advance', 'off'
    const [time, setTime] = useState(false);
    const [callStrategy, setCallStratergy] = useState([])
    const [showEditModal, setShowEditModal] = useState(false)
    const [showToastModal, setShowToastModal] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [assignedAgents, setAssignedAgents] = useState([]);
    const [availableAgents, setAvailableAgents] = useState([]);
    const [groupId, setGroupId] = useState(location.state?.groupId);
    const [editData, setEditData] = useState({
        id: '',
        startTime: "00:00",
        endTime: "23:59",
        weekDays: [],
        agent_id: ''
    });
    const [timeScheduledDate, setTimeScheduledDate] = useState({
        startTime: "00:00",
        endTime: "23:59",
        weekDays: [],
    });
    const [timeScheduleWholeDay, setTimeScheduleWholeDay] = useState(true);
    const [editDataWholeDay, setEditDataWholeDay] = useState(false);
    const [showMusicOnHold, setShowMusicOnHold] = useState(false);
    const [priorityError, setPriorityError] = useState(false);



    const [wholeDay, setWholeDay] = useState(true);
    const [groupScheduledId, setGroupScheduledId] = useState('');
    const [selectedWhisper, setSelectedWhisper] = useState('');
    const [selectedMusicHold, setSelectedMusicHold] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isDataLoaded, setIsDataLoaded] = useState(false);



    const storedUser = (() => {
        try {
            const raw = localStorage.getItem('user');
            return raw ? JSON.parse(raw) : null;
        } catch (e) {
            console.error('Failed to parse user from localStorage', e);
            return null;
        }
    })();
    const loggedInUserId = storedUser?.id;


    useEffect(() => {
        getApiCall(`${API_PROMPT_ACTIVE_LIST}/${loggedInUserId}`)
            .then(onPromptsSuccess)
            .catch(onError)
    }, []);


    function onPromptsSuccess(resp) {
        setAudio(resp)
    }

    function onError(err) {
        console.log(err);
    }

    const [audio, setAudio] = useState([]);



    const handleWholeDayChange = (e) => {
        const isChecked = e.target.checked;
        setWholeDay(isChecked);

        if (isChecked) {
            setStartTime("00:00");
            setEndTime("23:59");
        } else {
            setStartTime("");
            setEndTime("");
        }
    };

    const handleStartTimeChange = (e) => {
        if (!wholeDay) {
            setStartTime(e.target.value);
        }
    };

    const handleEndTimeChange = (e) => {
        if (!wholeDay) {
            setEndTime(e.target.value);
        }
    };


    const showToast = (message) => {
        setToastMessage(message);
        setShowToastModal(true);

        // Hide modal automatically after 3 seconds
        setTimeout(() => {
            setShowToastModal(false);
        }, 3000);
    };

    const handleAddMembersClick = () => {
        setShowAddMembersModal(true);
    };

    const handleModalClose = () => {
        setShowAddMembersModal(false);
    };

    const handleTimeScheduleClick = () => {
        setStartTime("");
        setEndTime("");
        // Prefill times when Whole Day is selected
        if (timeScheduleWholeDay) {
            setTimeScheduledDate({
                startTime: "00:00",
                endTime: "23:59",
                weekDays: timeScheduledDate.weekDays || [],
            });
        }
        setShowTimeScheduleModal(true);
    };


    const handleTimeScheduleClose = () => {
        setTime(true)
        setShowTimeScheduleModal(false);
    };

    const handleWhisperClick = () => {
        setShowWhisperModal(true);
    };

    const handleWhisperClose = () => {
        setShowWhisperModal(false);
    };

    const handleCallStrategyClick = () => {
        setShowCallStrategyModal(true);
    };

    const handleCallStrategyCloseall = () => {
        setShowCallStrategyModal(false);
    }

    const handleCallStrategyClose = () => {

        const finalPayload = {
            strategy: selectedStrategy,
            type: 'strategy'
        }

        postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), finalPayload).then((response) => {
            if (response) {
                setShowCallStrategyModal(false)
                showToast('Call Stratergy Updated');
                setShowAddMembersModal(false);
            }
        }).catch((err) => {
            toast.error(err)
        })
        setShowCallStrategyModal(false);
    };

    const handleSaveTimeSchedule = () => {
        // Validate week days
        if(timeScheduledDate.weekDays==0 || !timeScheduledDate.weekDays || timeScheduledDate.weekDays.length === 0)
        {
            toast.error('Please select atleast one week day',{
                duration:4000,
            })
            return;
        }

        // Validate start and end time when whole day is not selected
        if (!timeScheduleWholeDay) {
            if (!timeScheduledDate.startTime || timeScheduledDate.startTime.trim() === '' || timeScheduledDate.startTime === '--:-- --') {
                toast.error("Please select a start time", {
                    duration: 4000,
                });
                return;
            }
            if (!timeScheduledDate.endTime || timeScheduledDate.endTime.trim() === '' || timeScheduledDate.endTime === '--:-- --') {
                toast.error("Please select an end time", {
                    duration: 4000,
                });
                return;
            }
            if (timeScheduledDate.startTime > timeScheduledDate.endTime) {
                toast.error("Start time must be earlier than end time", {
                    duration: 4000,
                });
                return;
            }
        }

        const payload = {
            ...timeScheduledDate,
            type: 'time_schedule',
            group_schedule_id: groupScheduledId,
            startTime: timeScheduleWholeDay ? "00:00" : timeScheduledDate.startTime,
            endTime: timeScheduleWholeDay ? "23:59" : timeScheduledDate.endTime,
        }

        postApiCall(`/v2/agent-group/${groupId}`, payload)
            .then((response) => {
                if (response) {
                    setGroupScheduledId(response?.agent?.id)
                    setShowTimeScheduleModal(false);
                    showToast('Time Schedule Updated');
                }
            })
            .catch((err) => {
                toast.error(err);
            });
    };

    // `/v1/agent-group/${groupId}`

    const getAgentGroupData = async () => {
        try {
            setIsLoading(true);
            const response = await getApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId));
            if (response) {
                setTimeScheduledDate({
                    startTime: response?.group_schedule_id?.start_time || '',
                    endTime: response?.group_schedule_id?.end_time || '',
                    weekDays: response?.group_schedule_id?.week_days || []
                });
                setSelectedStrategy(response?.strategy || "ROUNDROBIN RINGING")
                setSelectedWhisper(response?.whisper_id || '')
                // Convert sticky to boolean (handle both true/false and 1/0 from database)
                setSticky(response?.sticky === true || response?.sticky === 1)
                setSelectedMusicHold(response?.music_on_hold || null)
                setStickyMember(response?.sticky_member || 'off') // Load sticky member setting
                setAgentGroup(response);
                setGroupScheduledId(response.group_schedule_id)
                setIsDataLoaded(true);
            } else {
                toast.error("Failed to fetch assigned agents.");
                setIsDataLoaded(true);
            }
        } catch (error) {
            console.error("Error fetching assigned agents:", error);
            toast.error("Error fetching assigned agents.");
            setIsDataLoaded(true);
        } finally {
            setIsLoading(false);
        }
    };



    const handleEditClick = (agent) => {
        setEditData({
            agent_id: agent?.agent_id || agent?.agent_id,
            id: agent.schedule?.id || agent.schedule?.id,
            startTime: agent.schedule?.start_time || "00:00",
            endTime: agent.schedule?.end_time || "23:59",
            weekDays: agent.schedule?.week_days || ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
            priority: agent?.priority || ''
        });
        if (agent.schedule?.start_time === "00:00" && agent.schedule?.end_time === "23:59") {
            setEditDataWholeDay(true)
        }
        setPriorityError(false);
        setShowEditModal(true);
    };


    // `/v1/agent-group/${groupId}/assigned-agents`

    const fetchAgentData = async () => {
        try {
            const [agentsResponse, assignedAgentsResponse] = await Promise.all([
                getApiCall(API_AGENTS_LIST),
                getApiCall(API_AGENT_GROUP_ASSIGNED_AGENTS.replace(':id', groupId))
            ]);

            if (agentsResponse && assignedAgentsResponse) {

                // Get a set of assigned agent IDs
                const assignedAgentIds = new Set(
                    assignedAgentsResponse.map((assigned) => assigned.agent_id)
                );

                // Filter and get full agent objects that are not already assigned
                const available = agentsResponse.filter(
                    (agent) => !assignedAgentIds.has(agent.id)
                );

                setAvailableAgents(available);
                setAssignedAgents(assignedAgentsResponse);
            }

        } catch (error) {
            console.error("Error fetching agents:", error);
            toast.error("Failed to fetch agent data.");
        }
    };



    const handleAddMembersSave = async () => {

        if (startTime > endTime) {
            toast.error("Start time should start earlier than the end time", {
                duration: 4000,
            });
            return;
        }

        if(memberWeekDays==0)
        {
          toast.error('Please select atleat one week day',{
            duration:4000,
          });
          return;
        }

        

        const selectedAgents = availableAgents
            .filter((agent) => selectedAgentIds.includes(agent.id))
            .map((agent) => ({
                ...agent,
                startTime,
                endTime,
                is_allocated: 1, // Mark agent as allocated
            }));

            if (selectedAgents.length === 0) {
               toast.error("Please select at least one agent before adding a member.", {
               duration: 4000,
            });
            return;
            }
        const AddmemberPayload = {
            type: 'add_member',
            agent_id: selectedAgents.map((data) => data.id),
            member_count: selectedAgents?.length,
            memberSchedulePayload: {
                week_days: memberWeekDays,
                start_time: startTime,
                end_time: endTime,
            }
        };

        try {
            // Step 1: Update agents in the group
            const [addMembersResponse] = await Promise.all([
                postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), AddmemberPayload),
            ]);
            if (addMembersResponse) {
                showToast('Members added, schedules updated, and allocation updated successfully');

                setAssignedAgents((prev) => [...prev, ...selectedAgents]);
                setAvailableAgents((prev) =>
                    prev.filter((agent) => !selectedAgentIds.includes(agent.id))
                );

                setSelectedAgentIds([]);
                setShowAddMembersModal(false);
                await fetchAgentData();
            } else {
                toast.error("Failed to complete all member actions. Please try again.");
            }
        } catch (error) {
            console.error("Error in handleAddMembersSave:", error);
            toast.error(`Error: ${error.message || 'Something went wrong'}`);
        }
    };





    const handleSticky = (value) => {
        // Only update state, don't save immediately
        setSticky(value);
    }


    const handleMusicOnHold = (value) => {
        // Only update state, don't save immediately
        if (value) {
            setShowMusicOnHold(true)
            // Don't set selectedMusicHold here, let user select from modal
        } else {
            setSelectedMusicHold(null)
            setShowMusicOnHold(false)
        }
    }

    const handleStickyMemberChange = (value) => {
        // Only update state, don't save immediately
        setStickyMember(value);
    }

    const fetchCallStratergies = () => {

        getApiCall(API_CALL_STRATEGIES_MASTER_LIST).then((data) => {
            console.log("call stratergies data", data)
            setCallStratergy(data);
        }).catch((err) => {
            toast.error("Error fetching call stratergies", { duration: 4000 })
        })
    }

    // useEffect(async () => {
    //     if (location.state?.groupId) {
    //         setGroupId(location.state.groupId);
    //     }
    //     await fetchAgentData();
    //     fetchCallStratergies();
    //     await getAgentGroupData()
    // }, []);

    useEffect(() => {
        const fetchData = async () => {
            if (location.state?.groupId) {
                setGroupId(location.state.groupId);
            }

            await fetchAgentData();  // Pass groupId as a parameter
            fetchCallStratergies();
            await getAgentGroupData();
        };

        fetchData();
    }, []);

    const handleRemoveAgent = async (agentId) => {
        try {
            await postApiCall(`/v2/agent-group/remove-agent/${groupId}`, { agent_id: agentId });
            showToast('Agent removed successfully');
            await fetchAgentData()
        } catch (error) {
            toast.error('Failed to remove agent');
        }
    };

    const handleSaveAgentEdit = async () => {
        // Validate priority is mandatory
        if (!editData.priority || editData.priority === '' || editData.priority === null || editData.priority === undefined) {
            setPriorityError(true);
            toast.error("Priority is required and must be a number between 0 and 10", {
                duration: 4000,
            });
            return;
        }

        // Validate priority range
        const priorityNum = parseInt(editData.priority);
        if (isNaN(priorityNum) || priorityNum < 0 || priorityNum > 10) {
            setPriorityError(true);
            toast.error("Priority must be a number between 0 and 10", {
                duration: 4000,
            });
            return;
        }

        const finalPayload = {
            agent_id: editData.agent_id,
            id: editData.id,
            start_time: editData.startTime,
            end_time: editData.endTime,
            week_days: editData.weekDays,
            priority: editData.priority
        };


        if(finalPayload.week_days==0)
        {
            toast.error("Please select atleast one week day", {
                duration: 4000,
            });
            return;
        }
        

        await postApiCall(`/v2/agent-group/schedule/${groupId}`, finalPayload).then(async (response) => {
            if (response) {
                setShowEditModal(false);
                await fetchAgentData()
            }
        }).catch((err) => {
            console.error('Error updating agent time schedule:', err);
            toast.error('Failed to update agent time schedule');
        })

        // try {
        //     await postApiCall(`/v2/agent-group/schedule/${groupId}`, finalPayload);
        //     showToast('Agent time schedule updated successfully');
        //     setShowEditModal(false);

        //     setAssignedAgents((prev) =>
        //         prev.map((agent) =>
        //             agent.id === editData.id
        //                 ? {
        //                       ...agent,
        //                       time_schedule: {
        //                           start_time: formattedStartTime,
        //                           end_time: formattedEndTime,
        //                           week_days: editData.weekDays,
        //                       },
        //                   }
        //                 : agent
        //         )
        //     );
        // } catch (error) {
        //     console.error('Error updating agent time schedule:', error);
        //     toast.error('Failed to update agent time schedule');
        // }
    };

    const handlesave = async () => {
        try {
            const finalPayload = {
                sticky: sticky,
                sticky_member: stickyMember,
                music_on_hold: selectedMusicHold || null
            };

            await postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), finalPayload);
            showToast('Agent Group Settings Updated Successfully');
            // Optionally refresh the data to show updated values
            await getAgentGroupData();
        } catch (error) {
            console.error("Error saving settings:", error);
            toast.error(error || "Failed to save settings");
        }
    };

    const handleWhisperSave = () => {
        // Convert empty string to null for backend
        const whisperId = selectedWhisper && selectedWhisper !== '' ? selectedWhisper : null;

        const finalPayload = {
            whisper_id: whisperId,
        }

        postApiCall(API_SINGLE_AGENT_GROUP.replace(':id', groupId), finalPayload).then((response) => {
            if (response) {
                showToast('Whisper Updated');
                setShowWhisperModal(false);
                // Refresh data to show updated whisper
                getAgentGroupData();
            }
        }).catch((err) => {
            toast.error(err)
        })
    };

    const handleMusicHoldSave = () => {
        // Just close the modal, don't save immediately
        // The selectedMusicHold state will be saved when main Save button is clicked
        setShowMusicOnHold(false);
    };

    // Show loader while data is being fetched
    if (isLoading || !isDataLoaded) {
        return (
            <div style={{ marginTop: '20px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Body>
                                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                                    <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        );
    }

    return (
        <div style={{ marginTop: '20px' }}>
            <Toaster />
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header>
                            <h4>Group Settings</h4>
                        </Card.Header>
                        <Card.Body>
                            <p>You can configure the IVR settings according to the created call group from adding members to time schedules and call strategies.</p>

                            <div style={{ display: "flex", justifyContent: "flex-start", marginTop: "40px", gap: "60px", flexWrap: "wrap", paddingLeft: "20px", paddingRight: "20px" }}>

                                <button
                                    onClick={handleAddMembersClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #28a745',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(40, 167, 69, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#1e7e34';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#28a745';
                                    }}
                                >
                                    <span>+ Add Members</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="add-members-tooltip">
                                                Include your member in this group to assign workflows specifically according to time schedules and call strategies.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #28a745',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(40, 167, 69, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#28a745',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleTimeScheduleClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #007bff',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 123, 255, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#0056b3';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#007bff';
                                    }}
                                >
                                    <span>+ Time Schedule</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="time-schedule-tooltip">
                                                Account owner can configure when calls are routed to available members based on provided scheduled business hours.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #007bff',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(0, 123, 255, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#007bff',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleCallStrategyClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #6f42c1',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(111, 66, 193, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#5a32a3';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#6f42c1';
                                    }}
                                >
                                    <span>+ Call Strategy</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="call-strategy-tooltip">
                                                It provides a method to handle call flows for members with several extensions using a variety of routing strategies.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #6f42c1',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(111, 66, 193, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#6f42c1',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>

                                <button
                                    onClick={handleWhisperClick}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px',
                                        position: 'relative',
                                        padding: '12px 20px',
                                        minWidth: '146px',
                                        minHeight: '49px',
                                        backgroundColor: '#ffffff',
                                        border: '2px solid #fd7e14',
                                        borderRadius: '8px',
                                        color: '#333333',
                                        fontWeight: '500',
                                        fontSize: '12px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(253, 126, 20, 0.2)';
                                        e.currentTarget.style.transform = 'translateY(-2px)';
                                        e.currentTarget.style.borderColor = '#dc6502';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.borderColor = '#fd7e14';
                                    }}
                                >
                                    <span>+ Agent Whisper</span>
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={
                                            <Tooltip id="agent-whisper-tooltip">
                                                Agent Whisper voice messages so that your team can hear this voice prompt first before connecting with the customer.
                                            </Tooltip>
                                        }
                                    >
                                        <div
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '20px',
                                                height: '20px',
                                                borderRadius: '50%',
                                                backgroundColor: '#ffffff',
                                                border: '1px solid #fd7e14',
                                                transition: 'all 0.2s ease',
                                                cursor: 'pointer',
                                                marginLeft: 'auto'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor = 'rgba(253, 126, 20, 0.1)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor = '#ffffff';
                                            }}
                                        >
                                            <FiInfo
                                                style={{
                                                    color: '#fd7e14',
                                                    fontSize: '12px'
                                                }}
                                            />
                                        </div>
                                    </OverlayTrigger>
                                </button>
                            </div>

                            {/* <div className="mb-3">
                                <div className="d-flex align-items-center">
                                    <button className="btn btn-danger btn-sm me-3" style={{backgroundColor:"#4D869C", border:"none"}} onClick={handleWhisperClick}>+ Configure Whisper</button>
                                    <p className="mb-0">Configure Whisper voice messages so that your team can hear this voice prompt first before connecting with the customer.</p>
                                </div>
                                <hr style={{ border: 'none', height: '1px', backgroundColor: '#dee2e6', margin: '0.5rem 0' }} />
                            </div> */}

                            <div className="mt-4">
                                <p>Only the assigned member will receive calls from the customer. If they don't pick up, the call will get forwarded to the next member automatically:</p>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="normal" 
                                            name="stickyMember" 
                                            className="form-check-input" 
                                            checked={stickyMember === 'normal'}
                                            onChange={() => handleStickyMemberChange('normal')} 
                                        />
                                        <label htmlFor="normal" className="form-check-label">Normal</label>
                                    </div>
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="advance" 
                                            name="stickyMember" 
                                            className="form-check-input" 
                                            checked={stickyMember === 'advance'}
                                            onChange={() => handleStickyMemberChange('advance')} 
                                        />
                                        <label htmlFor="advance" className="form-check-label">Advance</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            id="off" 
                                            name="stickyMember" 
                                            className="form-check-input" 
                                            checked={stickyMember === 'off'}
                                            onChange={() => handleStickyMemberChange('off')} 
                                        />
                                        <label htmlFor="off" className="form-check-label">Off</label>
                                    </div>
                                </div>
                                <hr />
                            </div>

                            <div className="mt-4">
                                <p>Multi IVR Sticky:</p>
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="multiIvrOn" 
                                            name="multiIvr" 
                                            className="form-check-input" 
                                            checked={sticky === true}
                                            onChange={() => handleSticky(true)} 
                                        />
                                        <label htmlFor="multiIvrOn" className="form-check-label" >On</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            id="multiIvrOff" 
                                            name="multiIvr" 
                                            className="form-check-input" 
                                            checked={sticky === false}
                                            onChange={() => handleSticky(false)} 
                                        />
                                        <label htmlFor="multiIvrOff" className="form-check-label">Off</label>
                                    </div>
                                </div>
                                <hr />
                            </div>

                            <div className="mt-4">
                                {/* <p>Multi IVR Sticky:</p> */}
                                <div className="d-flex align-items-center mb-3">
                                    <div className="form-check me-4">
                                        <input 
                                            type="radio" 
                                            id="musicOnHold" 
                                            name="music" 
                                            className="form-check-input" 
                                            checked={selectedMusicHold !== null && selectedMusicHold !== undefined}
                                            onChange={() => handleMusicOnHold(true)} 
                                        />
                                        <label htmlFor="musicOnHold" className="form-check-label" >Music On Hold</label>
                                    </div>
                                    <div className="form-check">
                                        <input 
                                            type="radio" 
                                            id="ringing" 
                                            name="music" 
                                            className="form-check-input" 
                                            checked={selectedMusicHold === null || selectedMusicHold === undefined}
                                            onChange={() => handleMusicOnHold(false)} 
                                        />
                                        <label htmlFor="ringing" className="form-check-label">Ringing</label>
                                    </div>
                                </div>
                                <hr />
                            </div>

                            <div className="mt-4 text-center">
                                <button className="btn btn-danger btncardy" onClick={handlesave}  >
                                    Save
                                </button>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>



            <div className="mt-4">
                <h5>Assigned Agents</h5>
                <table className="table table-bordered" style={{ marginTop: "20px" }}>
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Team Member Name</th>
                            <th>Mobile Number</th>
                            <th>Agent Status</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Prompt</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {assignedAgents.length > 0 ? (
                            assignedAgents.map((agent, index) => (
                                <tr key={agent?.agent_id}>
                                    <td>{index + 1}</td>
                                    <td>{agent?.agent_name}</td>
                                    <td>{agent?.agent_number}</td>
                                    <td>
                                        <div style={{ display: 'flex', gap: '4px', justifyContent: 'start', flexWrap: 'wrap' }}>
                                            {agent?.agentTelephony?.profile?.map((item) => (
                                                <button
                                                    key={item.type}
                                                    className={`btn btn-sm ${item.active_profile ? 'btn-success' : 'btn-danger'
                                                        }`}
                                                    style={{
                                                        padding: '2px 6px',
                                                        fontSize: '10px',
                                                        minWidth: '50px',
                                                    }}
                                                >
                                                    {item.type}
                                                </button>
                                            ))}
                                        </div>
                                    </td>
                                    <td>{agent?.schedule?.start_time || "00:00"}</td>
                                    <td>{agent?.schedule?.end_time || "23:59"}</td>
                                    <td>
                                        {selectedWhisper && selectedWhisper !== '' ? (
                                            audio.find(p => p.id === parseInt(selectedWhisper) || p.id === selectedWhisper)?.prompt_name || 
                                            (typeof selectedWhisper === 'string' ? selectedWhisper : 'N/A')
                                        ) : (
                                            <span style={{ color: '#999', fontStyle: 'italic' }}>No prompt</span>
                                        )}
                                    </td>
                                    <td>
                                        <div className="actions" style={{ display: 'flex', gap: '5px', justifyContent: 'center' }}>
                                            <div onClick={() => handleEditClick(agent)}>
                                                <EditIcon title="Edit" />
                                            </div>
                                            <div>
                                                <DeleteIcon
                                                    title="Delete"
                                                    handleCallback={() => handleRemoveAgent(agent?.agent_id || agent?.agent_id)}
                                                />
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="8" className="text-center">No assigned agents found</td>
                            </tr>
                        )}
                    </tbody>

                </table>
            </div>





            {/* Add Members Modal */}
            <Modal show={showAddMembersModal} onHide={handleModalClose} size="lg" centered>
                <Modal.Header closeButton >
                    <Modal.Title>Add Members in Call Group</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <Row>
                        <Col>
                            <div style={{
                                maxHeight: '300px',
                                overflowY: 'auto',
                                scrollbarWidth: 'thin', // For Firefox
                            }}>
                                <table className="table table-bordered" >
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Team Member Name</th>
                                            <th>Mobile Number</th>
                                            <th>

                                                <input
                                                    type="checkbox"
                                                    // style={{ marginLeft: '10px' }}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Select all agents
                                                            setSelectedAgentIds(availableAgents.map((agent) => agent.id));
                                                        } else {
                                                            // Deselect all agents
                                                            setSelectedAgentIds([]);
                                                        }
                                                    }}
                                                    checked={selectedAgentIds.length === availableAgents.length && availableAgents.length > 0}
                                                />
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {availableAgents.map((agent, index) => (
                                            <tr key={agent.id}>
                                                <td>{index + 1}</td>
                                                <td>{agent.agent_name}</td>
                                                <td>{agent.agent_number}</td>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedAgentIds.includes(agent.id)}
                                                        onChange={(e) => {
                                                            if (e.target.checked) {
                                                                setSelectedAgentIds((prev) => [...prev, agent.id]);
                                                            } else {
                                                                setSelectedAgentIds((prev) =>
                                                                    prev.filter((id) => id !== agent.id)
                                                                );
                                                            }
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>


                                </table>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form>
                                {/* Whole Day Checkbox */}
                                <Form.Check
                                    type="checkbox"
                                    label="Whole Day"
                                    id="wholeDay"
                                    className="mb-3"
                                    checked={wholeDay}
                                    onChange={handleWholeDayChange}
                                />

                                {/* Start Time */}
                                <Form.Group className="mb-3">
                                    <Form.Label>Start Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={startTime}
                                        placeholder="00:00:00 AM"
                                        disabled={wholeDay}
                                        onChange={handleStartTimeChange}
                                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                    />
                                </Form.Group>

                                {/* End Time */}
                                <Form.Group className="mb-3">
                                    <Form.Label>End Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={endTime}
                                        placeholder="11:59:59 PM"
                                        disabled={wholeDay}
                                        onChange={handleEndTimeChange}
                                        onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Select Days</Form.Label>
                                    <div>
                                        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map(
                                            (day) => (
                                                <Form.Check
                                                    inline
                                                    key={day}
                                                    label={day}
                                                    type="checkbox"
                                                    checked={memberWeekDays.includes(day)}
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            setmemberWeekDays((prev) => [...prev, day]);
                                                        } else {
                                                            setmemberWeekDays((prev) => prev.filter((d) => d !== day));
                                                        }
                                                    }}
                                                />
                                            )
                                        )}
                                    </div>
                                </Form.Group>
                            </Form>
                        </Col>
                    </Row>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleAddMembersSave}>Add member</Button>
                </Modal.Footer>
            </Modal>

            {/* Call strategy */}
            <Modal show={showCallStrategyModal} onHide={handleCallStrategyCloseall} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Select Call Strategy</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select a Strategy:</Form.Label>
                            <div>
                                {callStrategy.map(
                                    (strategy) => (
                                        <Form.Check
                                            style={{ marginTop: "5px" }}
                                            type="radio"
                                            key={strategy.name}
                                            label={strategy.name}
                                            name="callStrategy"
                                            id={strategy.name.replace(/\s+/g, "-").toLowerCase()}
                                            checked={selectedStrategy === strategy.name}
                                            onChange={() => setSelectedStrategy(strategy.name)}
                                        />
                                    )
                                )}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCallStrategyCloseall}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleCallStrategyClose}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>





            {/* Add Time Schedule Modal */}
            <Modal show={showTimeScheduleModal} onHide={handleTimeScheduleClose} size="lg" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Time Schedule Setting</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Check
                            type="checkbox"
                            label="Whole Day"
                            id="wholeDay"
                            className="mb-3"
                            checked={timeScheduleWholeDay}
                            onChange={(e) => {
                                setTimeScheduleWholeDay(e.target.checked);
                                setTimeScheduledDate((prev) => ({
                                    ...prev,
                                    startTime: e.target.checked ? "00:00" : "",
                                    endTime: e.target.checked ? "23:59" : "",
                                }));
                            }}
                        />

                        {/* Start Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>Start Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={timeScheduledDate.startTime}
                                placeholder="00:00"
                                disabled={timeScheduleWholeDay}
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                onChange={(e) =>
                                    setTimeScheduledDate((prev) => ({
                                        ...prev,
                                        startTime: e.target.value,
                                    }))
                                }
                            />
                        </Form.Group>

                        {/* End Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>End Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={timeScheduledDate.endTime}
                                placeholder="23:59"
                                disabled={timeScheduleWholeDay}
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                onChange={(e) =>
                                    setTimeScheduledDate((prev) => ({
                                        ...prev,
                                        endTime: e.target.value,
                                    }))
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Days</Form.Label>
                            <div>
                                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
                                    <Form.Check
                                        inline
                                        key={day}
                                        label={day}
                                        type="checkbox"
                                        checked={timeScheduledDate?.weekDays?.includes(day)}
                                        onChange={(e) => {
                                            setTimeScheduledDate((prev) => ({
                                                ...prev,
                                                weekDays: e.target.checked
                                                    ? [...prev.weekDays, day]
                                                    : prev.weekDays.filter((d) => d !== day),
                                            }));
                                        }}
                                    />
                                ))}
                            </div>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleTimeScheduleClose}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleSaveTimeSchedule}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* Show whisper model */}
            <Modal show={showWhisperModal} onHide={() => setShowWhisperModal(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Agent Whisper Prompt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Prompt</Form.Label>
                            <Form.Control
                                as="select"
                                name="audio"
                                value={selectedWhisper}
                                onChange={(e) => setSelectedWhisper(e.target.value)}
                            >
                                <option value="">Select Prompt</option>
                                {audio.map((actionKey) => {
                                    return (
                                        <option key={actionKey.id} value={actionKey.id}>
                                            {actionKey.prompt_name}
                                        </option>
                                    );
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleWhisperSave}>Submit</Button>
                    <Button variant="secondary" onClick={handleWhisperClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Music on Hold*/}
            <Modal show={showMusicOnHold} onHide={() => setShowMusicOnHold(false)} size="md" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Music On Hold Prompt</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Select Prompt</Form.Label>
                            <Form.Control
                                as="select"
                                name="audio"
                                value={selectedMusicHold}
                                onChange={(e) => setSelectedMusicHold(e.target.value)}
                            >
                                <option value="">Select Prompt</option>
                                {audio.map((actionKey) => {
                                    return (
                                        <option key={actionKey.id} value={actionKey.id}>
                                            {actionKey.prompt_name}
                                        </option>
                                    );
                                })}
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleMusicHoldSave}>Submit</Button>
                    <Button variant="secondary" onClick={() => setShowMusicOnHold(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            {/* LOTTIE MODEL FOR TOAST */}
            <Modal show={showToastModal} centered onHide={() => setShowToastModal(false)} size="sm">
                <Modal.Body className="text-center">
                    <h5>{toastMessage}</h5>
                    <LottieAnimation />
                </Modal.Body>
            </Modal>

            {/* EDIT MODAL */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Member Schedule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Check
                            type="checkbox"
                            label="Whole Day"   
                            id="wholeDay"
                            className="mb-3"
                            checked={editDataWholeDay}
                            onChange={(e) => {
                                setEditDataWholeDay(e.target.checked);
                                setEditData((prev) => ({
                                    ...prev,
                                    startTime: e.target.checked ? "00:00" : "",
                                    endTime: e.target.checked ? "23:59" : "",
                                }));
                            }}
                        />

                        {/* Start Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>Start Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={editData.startTime}
                                placeholder="00:00"
                                disabled={editDataWholeDay}
                                onChange={(e) =>
                                    setEditData((prev) => ({
                                        ...prev,
                                        startTime: e.target.value,
                                    }))
                                }
                            />
                        </Form.Group>

                        {/* End Time */}
                        <Form.Group className="mb-3">
                            <Form.Label>End Time</Form.Label>
                            <Form.Control
                                type="time"
                                value={editData.endTime}
                                placeholder="23:59"
                                disabled={editDataWholeDay}
                                onChange={(e) =>
                                    setEditData((prev) => ({
                                        ...prev,
                                        endTime: e.target.value,
                                    }))
                                }
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Select Days</Form.Label>
                            <div>
                                {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((day) => (
                                    <Form.Check
                                        inline
                                        key={day}
                                        label={day}
                                        type="checkbox"
                                        checked={editData?.weekDays?.includes(day)}
                                        onChange={(e) => {
                                            setEditData((prev) => ({
                                                ...prev,
                                                weekDays: e.target.checked
                                                    ? [...prev.weekDays, day]
                                                    : prev.weekDays.filter((d) => d !== day),
                                            }));
                                        }}
                                    />
                                ))}
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>
                                Priority <span style={{ color: "red", margin: "0 4px" }}>*</span>
                            </Form.Label>
                            <Form.Control
                                type="number"
                                name="priority"
                                min="0"
                                max="10"
                                required
                                value={editData.priority}
                                placeholder={priorityError ? "Priority is required (0-10)" : "Enter priority (0-10)"}
                                style={{
                                    borderColor: priorityError ? '#dc3545' : undefined,
                                    backgroundColor: priorityError ? '#fff5f5' : undefined
                                }}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const numValue = parseInt(value);
                                    
                                    // Validate on change
                                    if (value === '') {
                                        setPriorityError(true);
                                        setEditData((prev) => ({
                                            ...prev,
                                            priority: value,
                                        }));
                                    } else if (isNaN(numValue) || numValue < 0 || numValue > 10) {
                                        setPriorityError(true);
                                        setEditData((prev) => ({
                                            ...prev,
                                            priority: value,
                                        }));
                                    } else {
                                        setPriorityError(false);
                                        setEditData((prev) => ({
                                            ...prev,
                                            priority: value,
                                        }));
                                    }
                                }}
                            />
                            {priorityError && (
                                <Form.Text className="text-danger" style={{ fontSize: '0.875rem' }}>
                                    {!editData.priority || editData.priority === '' 
                                        ? "Priority is required and must be a number between 0 and 10"
                                        : "Priority must be a number between 0 and 10"
                                    }
                                </Form.Text>
                            )}
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={handleSaveAgentEdit}
                    >
                        Save Changes
                    </Button>

                </Modal.Footer>
            </Modal>




        </div>
    );
};

export default GroupSettings;
